module.exports = __webpack_public_path__ + "static/media/tapari_tey.cddd7891.ogg";